import { createResourceCollection } from '@/request'
import { ActiveThermostatSettings } from '@/types/activeThermostatSettings'

/**
 * Client for `GET /api/active_thermostat_settings/<thermostat_id>/`.
 *
 * The response body has no `id` field, but does have `thermostat_id` —
 * `computedId` derives a stable cache key from it.
 */
export const thermostatActiveSettingsCollection = createResourceCollection<
  ActiveThermostatSettings & { id: string }
>({
  name: 'thermostatActiveSettings',
  selector: (state) => state.thermostatActiveSettings,
  computedId: (data) =>
    `thermostatActiveSettings:thermostat_id:${data.thermostat_id}`,
  apiConfig: {
    path: 'active_thermostat_settings',
  },
})

export default thermostatActiveSettingsCollection.slice.reducer
